/* DreamCatcher slide-out cart: add-on buttons and refreshing the drawer. */
(function () {
  if (window.__dcCart) return;
  window.__dcCart = true;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function sectionIds() {
    var d = drawer();
    if (!d || typeof d.getSectionsToRender !== 'function') return 'cart-drawer,cart-icon-bubble';
    return d.getSectionsToRender().map(function (s) { return s.id; }).join(',');
  }

  function inAddonForm(el) {
    return el && el.closest ? el.closest('form[data-dc-addon]') : null;
  }

  // The add-on cards sit inside Dawn's <cart-drawer-items>, which treats every 'change' event as a
  // quantity edit ("You can only add this item in increments of undefined"). Keep the add-on
  // option dropdowns' events away from it.
  ['change', 'input'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (inAddonForm(e.target)) e.stopPropagation();
    }, true);
  });

  // Re-render the drawer from the server (used after add-ons that are added outside the product form).
  window.dcCartRefresh = function () {
    var d = drawer();
    if (!d) return Promise.resolve();
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?sections=' + sectionIds(), {
      headers: { 'X-DC-Cart': '1' }
    })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (typeof d.renderContents === 'function') d.renderContents({ sections: sections });
      })
      .catch(function () {});
  };

  document.addEventListener('submit', function (e) {
    var form = inAddonForm(e.target);
    if (!form) return;
    e.preventDefault();

    var idField = form.querySelector('[name="id"]');
    var btn = form.querySelector('.dc-xsell__add');
    var err = form.querySelector('.dc-xsell__error');
    if (!idField || !idField.value) return;
    if (typeof idField.setCustomValidity === 'function') idField.setCustomValidity('');
    if (btn) btn.disabled = true;
    if (err) err.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-DC-Cart': '1' },
      // dc_addon keeps the product page's bundle script from adding its checked spools a second time
      body: JSON.stringify({
        items: [{ id: Number(idField.value), quantity: 1 }],
        sections: sectionIds(),
        attributes: { dc_addon: 'true' }
      })
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        if (!res.ok) {
          if (err) err.textContent = res.json.description || res.json.message || 'Could not add this item.';
          if (btn) btn.disabled = false;
          return;
        }
        var d = drawer();
        if (d && typeof d.renderContents === 'function' && res.json.sections) {
          d.renderContents(res.json);
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dc-cart-addon', cartData: res.json });
        }
      })
      .catch(function () {
        if (err) err.textContent = 'Could not add this item. Please try again.';
        if (btn) btn.disabled = false;
      });
  });
})();
